// Actions
const typePrefix = "previewScroll/";
const SET = `${typePrefix}SET`;
const CLEAR = `${typePrefix}CLEAR`;

// Selectors

export const getPreviewScroll = state => state.previewScroll;

// Action creators
export const setPreviewScroll = ({ position }) => ({
  type: SET,
  position
});

export const clearPreviewScroll = { type: CLEAR };

const emptyState = 0;

// Reducer
export function previewScrollReducer(state = emptyState, action = {}) {
  switch (action.type) {
    case SET:
      return action.position;
    case CLEAR:
      return 0;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/previewScroll/index.js